import { useEffect, useState } from 'react';
import { Modal } from "react-bootstrap";
import CustomTextInput from '../../../../components/CustomTextInput';
import TedarikciFirmaSecimi from '../../../../components/TedarikciFirmaSecimi';
import { CustomSingleSelectModel } from '../../../../components/CustomSingleSelect';

interface Props {
    isShown: boolean
    onConfirm: (_adSoyad: string, _firma: CustomSingleSelectModel) => void
    onClose: () => void
}

/**
 * Mesai tablosundan hızlı personel tanımı. Yalnız Ad Soyad ve Firma istenir;
 * firma, firma tanımlarında yoksa tedarikçi olarak oluşturulur ve personel
 * ona bağlanır. Tanımlanan personel açılan satıra seçilir.
 */
const YeniPersonelModal = ({ isShown, onConfirm, onClose }: Props) => {
    const [adSoyad, setAdSoyad] = useState<string | undefined>('');
    const [firma, setFirma] = useState<CustomSingleSelectModel | undefined>(undefined);

    useEffect(() => {
        if (isShown) {
            setAdSoyad('');
            setFirma(undefined);
        }
    }, [isShown])

    const kaydet = () => {
        if (firma)
            onConfirm((adSoyad ?? '').trim(), firma);
    }

    const dolu = (adSoyad ?? '').trim() != '' && firma != undefined;

    return (
        <Modal
            tabIndex={-1}
            dialogClassName='modal-dialog modal-dialog-centered mw-500px'
            show={isShown}
            onHide={onClose}
            backdrop={'static'}
            keyboard={false}
        >
            <div className='modal-header'>
                <h2 className='mb-0'>Yeni Personel</h2>
            </div>

            <div className='modal-body'>
                <div className='mb-5'>
                    <CustomTextInput labelText="Ad Soyad" isLabelRequired value={adSoyad} setValue={setAdSoyad} />
                </div>

                <div className='mb-5'>
                    <TedarikciFirmaSecimi isLabelRequired selectedValue={firma} onChange={setFirma} />
                </div>

                <div className='alert alert-primary d-flex align-items-start p-4 mb-0'>
                    <i className='fa fa-info-circle text-primary fs-3 me-3 mt-1'></i>
                    <div className='fs-7'>
                        Firma listede varsa seçin; yoksa <b>+</b> ile adını yazın, <b>tedarikçi</b> olarak
                        oluşturulur. Personel bu firmaya bağlanır ve tabloda Firma alanı kendiliğinden dolar.
                    </div>
                </div>
            </div>

            <div className="modal-footer">
                <button onClick={onClose} type="button" className="btn btn-light">
                    Vazgeç
                </button>
                <button onClick={kaydet} disabled={!dolu} type="button" className="btn btn-success">
                    Kaydet ve Seç
                </button>
            </div>
        </Modal>
    )
}

export default YeniPersonelModal;
